import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef, signal, WritableSignal } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { IconButtonComponent } from '@libs/common/components';
import type { OrderHistoryRecordModel } from '@libs/services/models';
import { SrmCreateFormComponent } from '../../srm/srm-create-form';
import { OrderHistoryActionsComponent } from '../order-history-actions';
import { OrderHistoryDetailsComponent } from '../order-history-details';
import { OrderHistoryDocumentsComponent } from '../order-history-documents';
import type { OrderHistorySelectedPanelModel } from '../order-history-panel.model';

@Component({
  selector: 'ui-order-history-mobile',
  templateUrl: './order-history-mobile.component.html',
  styleUrls: ['./order-history-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OrderHistoryDetailsComponent,
    OrderHistoryActionsComponent,
    OrderHistoryDocumentsComponent,
    IconButtonComponent,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    SrmCreateFormComponent,
  ],
})
export class OrderHistoryMobileComponent {
  public orders: InputSignal<OrderHistoryRecordModel[]> = input.required();
  public openSrmForm: OutputEmitterRef<OrderHistoryRecordModel> = output<OrderHistoryRecordModel>();

  public selected: WritableSignal<OrderHistorySelectedPanelModel | undefined> = signal(undefined);

  public onOpenSrmForm(order: OrderHistoryRecordModel): void {
    this.openSrmForm.emit(order);
    this.selected.set({ order, panel: 'srm' });
  }

  public onOpenDocuments(order: OrderHistoryRecordModel): void {
    const isSameDocumentsPanelOpen: boolean = this.selected()?.panel === 'documents' && this.selected()?.order.id === order.id;

    this.selected.set(isSameDocumentsPanelOpen ? undefined : { order, panel: 'documents' });
  }

  public onPanelClosed(): void {
    this.selected.set(undefined);
  }
}
